import LicensedDocumentation from "./LicensedDocumentation";

export default LicensedDocumentation;
